import React, { useState, useEffect } from "react";
import "./style.scss";
const Meetings = ({ Brief, Professionals, SelectedProf, AllUsers }) => {
  const [TheProf, setTheProf] = useState({})

  useEffect(() => {
    processSelectedProf();
  }, [SelectedProf])

  function processSelectedProf() {
    const pro = Professionals.find((item) => item._id === SelectedProf.id)
    if (typeof pro === 'object' && pro !== null && pro !== undefined) {
      setTheProf(pro);
    } else {
      setTheProf({})
    };
  };
  const calculateDurationInHours = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.abs(end - start) / (1000 * 60 * 60) || 0;
  };
  const formatDate = (inputDate) => {
    if (inputDate === undefined || !inputDate) {
      return `00/00/0000`
    }
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const extractTime = (dateString) => {
    if (!dateString) return '00:00';
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };
  const formatMessageDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // Check if date is today
    if (date.toDateString() === now.toDateString()) {
      return 'Today';
    }

    // Check if date was yesterday
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    }

    // If within a week, return day name
    if (diffDays < 7) {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      return days[date.getDay()];
    }

    // If older than a week, return full date
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const sortByTime = (array, dateField = 'startDate') => {
    return [...array].sort((a, b) => {
      const timeA = extractTime(a[dateField]);
      const timeB = extractTime(b[dateField]);
      return timeA.localeCompare(timeB);
    });
  };

  const findUserName = (userId) => {
    if (!userId || !AllUsers) return 'Unknown User';
    const user = AllUsers.find(user => user._id === userId);
    return user ? `${user.firstName} ${user.lastName}` : 'Unknown User';
  };

  return (
    <div className="meeting-container">

      <p className="header">Professional Details</p>
      <div className="meeting-content">
        <div className="meeting-notes_name">
          <p className="innerheader">Notes</p>
          <div className="notes-div">
            <p className="p-name-header">{formatMessageDate(Brief.scheduledCallNotes[Brief.scheduledCallNotes.length - 1]?.date)}</p>
            <div className="notes-body">
              {Brief.scheduledCallNotes.map((item) => {
                
                if (Object.keys(TheProf).length > 0) {
                  let sender = AllUsers.find((jtem) => { return jtem._id === item.from });

                  if (TheProf._id === sender._id || sender.roles[0] !== 1988) {
                    return (
                      <div className="name-div-item-top" style={{ marginTop: '2%', minHeight: '10%', height: 'auto' }}>
                        <p className="p-name">{findUserName(item.from)}</p>
                        <p className="p-email" style={{ margin: '2% 0px', display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{maxWidth:'86%',}}>{item.notes}</span>
                          <span style={{ minHeight: '100%', color: 'var(--purple)', fontSize: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>{extractTime(item.date)}</span>
                        </p>
                      </div>
                    )
                  } 
                }
              })}
            </div>
          </div>
        </div>

        <div className="meeting-notes_name">
          <div className="name-div">
            <div className="name-div-item-top">
              <p className="p-name">Name</p>
              <p className="p-email">{`${TheProf?.firstName ?? ''} ${TheProf.lastName ?? ''}`}</p>
            </div>
            <div className="name-div-item-top">
              <p className="p-name">Email Address</p>
              <p className="p-email">{TheProf.email ?? ''}</p>
            </div>
            <div className="name-div-item-bottom">
              <p className='innerheader'>Availability</p>
              <div className="name-div-item-bottom-content">
                {Array.isArray(Brief.projectPlan) && Brief.projectPlan.length > 0 ?
                  Object.keys(Brief.projectPlan[0]).includes('workHours') && Array.isArray(Brief.projectPlan[0].workHours) &&
                  Brief.projectPlan[0].workHours.map((xItem, index) => {
                    return (
                      <p className="avaliability">
                        <span>{xItem.day}</span>
                        <span>{xItem.timeFrom}- {xItem.timeTo}</span>
                      </p>
                    )
                  })
                  : null
                }

              </div>
            </div>
          </div>
        </div>

        <div className="meeting-schedule">

          <p className="innerheader">Meeting Schedule</p>
          <div className="meeting-schedule-content">
            <div className="meeting-schedule-table-header">
              <p style={{ width: "30%", paddingLeft: "1%" }}>Meetings</p>
              <p style={{ width: "20%" }}>Date</p>
              <p style={{ width: "10%" }}>Time</p>
              <p style={{ width: "20%" }}>Duration</p>
              <p style={{ width: "20%" }}>Status</p>
            </div>

            <div className="meeting-schedule-table-content">
              {sortByTime(Brief.scheduledCalls).map((meeting, index) => {
                if (Object.keys(TheProf).includes('_id')) {
                  if (TheProf._id === meeting.professional) {
                    return (<div className="meeting-schedule-table-content-item">
                      <p style={{ width: "30%", peddingLeft: "1%", overflow: 'hidden' }}>Meeting {index + 1}</p>
                      <p style={{ width: "20%" }}>{formatDate(meeting.startDate)}</p>
                      <p style={{ width: "10%" }}>{extractTime(meeting.startDate)}</p>
                      <p style={{ width: "20%" }}>{calculateDurationInHours(meeting.startDate, meeting.endDate)} Hours</p>
                      <p style={{ width: "20%", color: String(meeting.status) === 'PROFESSIONAL_DECLINED' ? '#F26640' : '' }}>{meeting.status === 'PROFESSIONAL_DECLINED' ? 'DECLINED' : meeting.status === 'PROFESSIONAL_ACCEPTED' ? 'ACCEPTED' : meeting.status}</p>
                    </div>)
                  }
                }
              })}
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Meetings;